import { Controller } from "@hotwired/stimulus"

// 汎用ホバーツールチップ。 CSS の `group-hover:block absolute` はテーブル / モーダル等の
// overflow を持つ親に切られるため、 本コントローラーは content 要素を document.body に
// 一時的に付け替えて `position: fixed` で表示することで、 どんな親要素に置いても切れない。
//
// 使い方:
//   %div{data: { controller: "hover-tooltip" }}
//     = ホバーする対象 ( バッジ等 )
//     %div{class: "hidden", data: { hover_tooltip_target: "content" }}
//       ツールチップの中身
//
// NOTE: ツールチップを切らないための共通実装。 「ホバーで詳細を出したい」 UI は今後もこれを使うこと。
export default class extends Controller {
  static targets = ["content"]

  connect() {
    if (!this.hasContentTarget) return
    // 対象要素の参照を保持しておく ( body に付け替えると Stimulus の target 探索から外れるため )
    this.tooltipEl = this.contentTarget
    this.originalParent = this.tooltipEl.parentNode
    this.originalNextSibling = this.tooltipEl.nextSibling
    this.showBound = this.show.bind(this)
    this.hideBound = this.hide.bind(this)
    this.element.addEventListener("mouseenter", this.showBound)
    this.element.addEventListener("mouseleave", this.hideBound)
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.showBound)
    this.element.removeEventListener("mouseleave", this.hideBound)
    this.restore()
  }

  show() {
    if (!this.tooltipEl) return
    // body 直下に付け替え ( 親の overflow を回避 )
    if (this.tooltipEl.parentNode !== document.body) {
      document.body.appendChild(this.tooltipEl)
    }
    this.tooltipEl.style.position = "fixed"
    this.tooltipEl.style.zIndex = "9999"
    this.tooltipEl.style.pointerEvents = "none"
    this.tooltipEl.classList.remove("hidden")
    // 位置計算 ( trigger 直下、 画面外なら上に、 右端超過は寄せる )
    const triggerRect = this.element.getBoundingClientRect()
    const contentRect = this.tooltipEl.getBoundingClientRect()
    const margin = 4
    let top = triggerRect.bottom + margin
    if (top + contentRect.height > window.innerHeight - margin) {
      top = Math.max(margin, triggerRect.top - contentRect.height - margin)
    }
    let left = triggerRect.left
    if (left + contentRect.width > window.innerWidth - margin) {
      left = Math.max(margin, window.innerWidth - contentRect.width - margin)
    }
    this.tooltipEl.style.top = `${top}px`
    this.tooltipEl.style.left = `${left}px`
  }

  hide() {
    if (!this.tooltipEl) return
    this.tooltipEl.classList.add("hidden")
    this.restore()
  }

  restore() {
    if (!this.tooltipEl || !this.originalParent) return
    if (this.tooltipEl.parentNode === document.body) {
      if (this.originalNextSibling && this.originalNextSibling.parentNode === this.originalParent) {
        this.originalParent.insertBefore(this.tooltipEl, this.originalNextSibling)
      } else {
        this.originalParent.appendChild(this.tooltipEl)
      }
    }
  }
}
